import { ProductFormat } from 'components/common/types/AssetList.types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getProductFormats } from 'modules/api/inventory';
import { formatFilterOptionsName } from 'utils/formatters';
import { FilterProductFormatProps } from './FilterProductFormat.types';

const FilterProductFormat: React.FC<FilterProductFormatProps> = ({ changeFilters, productFormat }) => {
  const fetchProductFormats = async (query: string): Promise<ProductFormat[]> => {
    if (query.length >= 3) {
      try {
        return await getProductFormats(cancelFunctions, query);
      } catch (error) {
        return [];
      }
    }
    return [];
  };

  const loadFilterOptions: AsyncSelectLoadDataHandler<ProductFormat> = async (_, query) => {
    return formatFilterOptionsName(await fetchProductFormats(query));
  };

  const onSelect: SelectHandler<ProductFormat> = (_, value: ProductFormat) => {
    changeFilters({ productFormat: value });
  };

  return (
    <AsyncSelect
      dataTestId="product-format"
      name="productFormat"
      loadData={loadFilterOptions}
      onSelect={onSelect}
      placeholder="PFCode01 - Product format name"
      selectedValue={productFormat}
    />
  );
};

export default FilterProductFormat;
